import {
  createDefaultStandupQuestions,
  createNominalQuestion,
  createOpenEndedQuestion,
  createOrdinalQuestion,
} from "@teams/client-shared";

import { AuthoringFields } from "../../../survey/pages/SurveyAuthoring/PollySurveyAuthoringForm";

export const DEFAULT_QUESTION_SURVEY_NOMINAL: AuthoringFields = {
  type: "poll",
  title: "",
  description: "",
  anonymity: "none",
  resultsVisibility: "real-time",
  openDuration: undefined,
  questions: [createNominalQuestion({ required: false })],
  sendAt: new Date(),
  commentsEnabled: false,
  commentsAppeal: "",
  rrule: "",
  reminders: [],
  deliveryMethod: "in-group",
  notifyUsersOnEdit: true,
  removeExistingVotesOnEdit: false,
};

export const DEFAULT_QUESTION_SURVEY_OPEN: AuthoringFields = {
  type: "poll",
  title: "",
  description: "",
  anonymity: "none",
  resultsVisibility: "real-time",
  openDuration: undefined,
  questions: [createOpenEndedQuestion({ required: false })],
  sendAt: new Date(),
  commentsEnabled: false,
  commentsAppeal: "",
  rrule: "",
  reminders: [],
  deliveryMethod: "in-group",
  notifyUsersOnEdit: true,
  removeExistingVotesOnEdit: false,
};

export const DEFAULT_QUESTION_SURVEY_ORDINAL: AuthoringFields = {
  type: "poll",
  title: "",
  description: "",
  anonymity: "none",
  resultsVisibility: "real-time",
  openDuration: undefined,
  questions: [createOrdinalQuestion({ required: false })],
  sendAt: new Date(),
  commentsEnabled: false,
  commentsAppeal: "",
  rrule: "",
  reminders: [],
  deliveryMethod: "in-group",
  notifyUsersOnEdit: true,
  removeExistingVotesOnEdit: false,
};

export const DEFAULT_QUIZ_SURVEY: AuthoringFields = {
  type: "quiz",
  title: "",
  description: "",
  anonymity: "none",
  resultsVisibility: "after-close",
  openDuration: undefined,
  questions: [createNominalQuestion({ pointValue: 1 }, undefined, undefined, true)],
  sendAt: new Date(),
  commentsEnabled: false,
  commentsAppeal: "",
  rrule: "",
  reminders: [],
  deliveryMethod: "in-group",
  notifyUsersOnEdit: false,
  removeExistingVotesOnEdit: false,
};

export const DEFAULT_AGILE_STANDUP_SURVEY: AuthoringFields = {
  type: "agile-standup",
  title: "",
  description: "",
  questions: createDefaultStandupQuestions(),
  sendAt: new Date(),
  rrule: "RRULE:FREQ=WEEKLY;INTERVAL=1;BYDAY=MO,TU,WE,TH,FR",
  openDuration: "PT3H",
  reminders: [],
  commentsEnabled: false,
  commentsAppeal: "",
  anonymity: "none",
  resultsVisibility: "real-time",
  deliveryMethod: "in-group",
  notifyUsersOnEdit: false,
  removeExistingVotesOnEdit: false,
};
